import { createTrackingUtils } from "../index.js";
const utils = createTrackingUtils({
    name: "flights_apps_genius_fares_rank_boost",
    stages: {},
    defaultStage: 1,
    goals: {
        clicked_on_airline_funded_offer: 1
    }
});
export default utils;
